<template>
  <div style="width: 600px; margin: 0 auto; ">
    <CustomAlert type="warning">
      <template v-slot:icon>
        !
      </template>

      <div class="text-xs-left">
        <span><strong class="font-weight-bold">ATENCIÓN:</strong> Recuerda que al ser una plataforma digital, puedes
          realizar
          solicitudes o envío de trámites en cualquier día y horario. Sin embargo los trámites serán recepcionados
          únicamente
          durante el horario administrativo de la AJ y en días habiles.</span>
        <!--<span><strong class="font-weight-bold">HORARIO ADMINSITRATIVO AJ:</strong> {{ horarioAtencion }}</span>-->
        <GlobalCardToolTip
          prepend-icon="info"
          icon-color="accent"
          width="360px"
          icon-size="18px"
        >
          <template #contenido>
            En cumplimiento al Art. 19 de la Ley N° 2341, todo envío de solicitud o presentación será recibido y
            procesado sólo en horarios administrativos de la AJ.
            En caso de que su solicitud fuera enviada después del horario administrativo, será recepcionada al siguiente
            día hábil.
          </template>
        </GlobalCardToolTip>
      </div>
    </CustomAlert>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import CustomAlert from "@/components/CustomAlert.vue";
import GlobalCardToolTip from "@/components/Global/GlobalCardToolTip.vue";
import typesDominios from "../store/types/Dominios.js";
import types from '@/store/types/SolicitudCredenciales'
import typesUsuario from '@/store/types/Usuario'

export default {
  name: "HorarioAtencion",
  components: {
    GlobalCardToolTip,
    CustomAlert
  },
  data() {
    return {
      horarioAtencion: '',
      oficinaId: -1,
    };
  },
  computed: {
    ...mapGetters({
      GetDatosSin: types.getters.GetDatosSin,
    }),
  },
  watch:{
    GetDatosSin(vn,va){
      this.ObtenerHoraAtencion()
    },
    oficinaId(vn,va){
      this.ObtenerHoraAtencion()
    }
  },
  mounted() {
    this.ObtenerHoraAtencion();
  },
  methods: {
    ...mapActions({
      ObtenerHorarioAtencion: typesDominios.actions.ObtenerHorarioAtencion,
      ObtenerIdOficina: typesUsuario.actions.ObtenerIdOficina
    }),
    ...mapMutations({
      SetHorarioAtencion: typesDominios.mutations.SetHorarioAtencion
    }),
    ObtenerHoraAtencion() {
      if (localStorage.getItem('pObjDatosSession')) {
        const datosSesion = JSON.parse(localStorage.getItem('pObjDatosSession'))
        this.oficinaId = datosSesion.oficinaId
      } else {
        this.ObtenerIdOficina(
          {dependencia:this.GetDatosSin.resultado.dependencia}
        ).then((r)=> {
          this.oficinaId=r.data.idOficina
        }).catch((error) => {
          console.log('Sin servicio para obtener la oficina.')
        })
      }
      if (this.oficinaId != -1) {
        this.ObtenerHorarioAtencion(this.oficinaId).then((r) => {
          const horarioDatos = r.data
          let horarios = r.data;
          let objeto
          this.horarioAtencion=''
          Object.keys(horarioDatos).forEach(propiedad => {
            objeto = horarioDatos[propiedad]
            this.horarioAtencion = this.horarioAtencion + objeto.turno.toLowerCase() + ' [' + objeto.horaInicio.substring(0, 5) + ' a ' + objeto.horaFin.substring(0, 5) + ']. '
          });
          this.SetHorarioAtencion(this.horarioAtencion, objeto.horaFin.substring(0, 5))
        })
      }
    },
  },
}
</script>
<style scoped></style>
